<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$(document).on('click', '.mobileMenu-toggle', function(e) {
  e.stopPropagation();
  $('body').addClass('menu_open');
  $('.halo-sidebar-wrapper').click();
});

$(document).on('click', '.header__search', function(e) {
  e.stopPropagation();
  $('body').addClass('open_search_mobile');
});

$(document).on('click', '.toolbar-sidebar', function(e) {
  e.stopPropagation();
  $('body').addClass('open-mobile-sidebar');
});

$(document).on('click', '.halo-sidebar-close', function(e) {
  e.stopPropagation();
  $('body').removeClass('menu_open open_search_mobile open-mobile-sidebar');
});

$(document).on('click', function(e) {
  if (!$(e.target).closest('.page-sidebar, .halo-sidebar, .halo-sidebar-wrapper').length) {
    $('body').removeClass('menu_open open_search_mobile open-mobile-sidebar');
  }
});

$(document).on('click', '.menu_mobile_link', function(e) {
  e.preventDefault();
  
  let $parent = $(this).parent();
  
  $parent.addClass('is-open');
  
  $parent.siblings().addClass('is-hidden');
});

$(document).on('click', '.menu_mobile_link_2', function(e) {
  e.preventDefault();
  
  let $parent = $(this).parents().eq(1);
  
  $parent.addClass('is-open');
  
  $parent.siblings().addClass('is-hidden');
});

jQuery('.menu-lv-1.dropdown a').on('click', function(e){
  var location_url = jQuery(this).attr('href');
  window.location.href = location_url;
})
